import { ProfileDesktopComponent } from '../profile-desktop.component';
import { ProfileMobileComponent } from '../profile-mobile.component';
import { ProfileComponent } from '../profile.component';
import { Profile2FAComponent } from './profile-2fa/profile-2fa.component';
import { Profile2FAHelpComponent } from './profile-2fa-help/profile-2fa-help.component';
import { Profile2FAPhoneComponent } from './profile-2fa-phone/profile-2fa-phone.component';
import { ProfileAddressComponent } from './profile-address/profile-address.component';
import { ProfileCategoryComponent } from './profile-category/profile-category.component';
import { ProfileChangeLanguageComponent } from './profile-change-language/profile-change-language.component';
import { ProfileChangePasswordComponent } from './profile-change-password/profile-change-password.component';
import { ProfileDialog2FAChangeComponent } from './profile-dialog-2fa-change/profile-dialog-2fa-change.component';
import { ProfileDialog2FADisableComponent } from './profile-dialog-2fa-disable/profile-dialog-2fa-disable.component';
import { ProfileDocumentsComponent } from './profile-documents/profile-documents.component';
import { ProfileEmailComponent } from './profile-email/profile-email.component';
import { ProfileFieldRowComponent } from './profile-field-row/profile-field-row.component';
import { ProfileI4kNamesComponent } from './profile-i4k-names/profile-i4k-names.component';
import { ProfileI4kRowComponent } from './profile-i4k-row/profile-i4k-row.component';
import { ProfileMobilePhoneComponent } from './profile-mobile-phone/profile-mobile-phone.component';
import { ProfileOtpCodeComponent } from './profile-otp-code/profile-otp-code.component';
import { ProfilePasswordComponent } from './profile-password/profile-password.component';
import { ProfilePersonalDetailsComponent } from './profile-personal-details/profile-personal-details.component';
import { ProfileValidatePasswordComponent } from './profile-validate-password/profile-validate-password.component';
import { ProfileVerifyComponent } from './profile-verify/profile-verify.component';

export const components = [
  ProfileDesktopComponent,
  ProfileMobileComponent,
  ProfileComponent,
  Profile2FAHelpComponent,
  Profile2FAPhoneComponent,
  Profile2FAComponent,
  ProfileCategoryComponent,
  ProfileChangeLanguageComponent,
  ProfileChangePasswordComponent,
  ProfileDialog2FAChangeComponent,
  ProfileDialog2FADisableComponent,
  ProfileDocumentsComponent,
  ProfilePasswordComponent,
  ProfilePersonalDetailsComponent,
  ProfileVerifyComponent,
  ProfileAddressComponent,
  ProfileFieldRowComponent,
  ProfileEmailComponent,
  ProfileMobilePhoneComponent,
  ProfileValidatePasswordComponent,
  ProfileOtpCodeComponent,
  ProfileI4kNamesComponent,
  ProfileI4kRowComponent
];

export * from '../profile-desktop.component';
export * from '../profile-mobile.component';
export * from '../profile.component';
export * from './profile-2fa-help/profile-2fa-help.component';
export * from './profile-2fa-phone/profile-2fa-phone.component';
export * from './profile-2fa/profile-2fa.component';
export * from './profile-category/profile-category.component';
export * from './profile-change-language/profile-change-language.component';
export * from './profile-change-password/profile-change-password.component';
export * from './profile-dialog-2fa-change/profile-dialog-2fa-change.component';
export * from './profile-dialog-2fa-disable/profile-dialog-2fa-disable.component';
export * from './profile-documents/profile-documents.component';
export * from './profile-personal-details/profile-personal-details.component';
export * from './profile-verify/profile-verify.component';
export * from './profile-address/profile-address.component';
export * from './profile-field-row/profile-field-row.component';
export * from './profile-email/profile-email.component';
export * from './profile-mobile-phone/profile-mobile-phone.component';
export * from './profile-password/profile-password.component';
export * from './profile-otp-code/profile-otp-code.component';
export * from './profile-i4k-names/profile-i4k-names.component';
export * from './profile-i4k-row/profile-i4k-row.component';
